// Mirrors BrainReviewReason and the "Reasons: A, B" line built by apps/api BrainIngestQueue reviewCard.ts.
export enum BrainReviewReasonCode {
  RESTRICTED = 'RESTRICTED',
  DISPUTED = 'DISPUTED',
  NOT_GROUNDED = 'NOT_GROUNDED',
  PROPOSED = 'PROPOSED',
  AUTO_PUBLISH_OFF = 'AUTO_PUBLISH_OFF',
  REVIEW_ALL = 'REVIEW_ALL',
}

export const BRAIN_REVIEW_REASON_LABEL_KEY: Record<
  BrainReviewReasonCode,
  string
> = {
  [BrainReviewReasonCode.RESTRICTED]: 'doBox.brainReview.reason.RESTRICTED',
  [BrainReviewReasonCode.DISPUTED]: 'doBox.brainReview.reason.DISPUTED',
  [BrainReviewReasonCode.NOT_GROUNDED]: 'doBox.brainReview.reason.NOT_GROUNDED',
  [BrainReviewReasonCode.PROPOSED]: 'doBox.brainReview.reason.PROPOSED',
  [BrainReviewReasonCode.AUTO_PUBLISH_OFF]:
    'doBox.brainReview.reason.AUTO_PUBLISH_OFF',
  [BrainReviewReasonCode.REVIEW_ALL]: 'doBox.brainReview.reason.REVIEW_ALL',
};

const REASONS_LINE_PREFIX = 'Reasons: ';
const REASON_SEPARATOR = ', ';
const LINE_BREAK = '\n';

const KNOWN_CODES = new Set<string>(Object.values(BrainReviewReasonCode));

function isReasonCode(value: string): value is BrainReviewReasonCode {
  return KNOWN_CODES.has(value);
}

function findReasonsLine(description: string): string | undefined {
  return description
    .split(LINE_BREAK)
    .reverse()
    .find((line) => line.startsWith(REASONS_LINE_PREFIX));
}

export function extractBrainReviewReasonCodes(
  description: string | null | undefined,
): BrainReviewReasonCode[] {
  const line = description ? findReasonsLine(description) : undefined;
  if (!line) {
    return [];
  }
  const codes = line
    .slice(REASONS_LINE_PREFIX.length)
    .split(REASON_SEPARATOR)
    .map((code) => code.trim())
    .filter(isReasonCode);
  return [...new Set(codes)];
}
